<template>
  <div id="app">
    <router-view v-if="!hideFetchRecordBanner" name="banner" />
    <DpNotificationContainer :notifications="notifications" :in-licensing-flow="!noLicensing" class="mt-3" />
    <main id="main" class="pt-4 pb-0">
      <DpPanel v-show="loading">
        <template v-slot:content>
          <dp-loading />
        </template>
      </DpPanel>
      <router-view v-show="!loading" v-if="!navigationError" />
      <DpError v-if="navigationError" />
    </main>
    <DpFooter :base-url="getBaseUrl" />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { DpPanel, DpFooter, DpLoading, DpError, DpNotificationContainer } from '@docupet/component-library';
import { NotificationMixin } from '@docupet/component-library/src/mixins/NotificationMixin';

export default {
  name: 'App',
  components: {
    DpPanel,
    DpFooter,
    DpLoading,
    DpError,
    DpNotificationContainer,
  },
  mixins: [NotificationMixin],
  computed: {
    ...mapState({
      loading: (state) => state.navigation.isLoading || state.register.loading,
      city: (state) => state.city.city,
    }),
    ...mapGetters('city', ['noLicensing', 'getAreaType', 'getFirstTimeLicensingOnly']),
    ...mapGetters(['getBaseUrl']),
    ...mapGetters('navigation', {
      navigationError: 'hasError',
    }),
    areaTypeIsProvinceOrStateOrCountry() {
      if (this.getAreaType) {
        return (
          this.getAreaType.toLowerCase() === 'province' ||
          this.getAreaType.toLowerCase() === 'state' ||
          this.getAreaType.toLowerCase() === 'country'
        );
      } else {
        return false;
      }
    },
    hideFetchRecordBanner() {
      return this.noLicensing || this.areaTypeIsProvinceOrStateOrCountry || this.getFirstTimeLicensingOnly;
    },
  },
};
</script>

<style lang="scss">
@import '~@docupet/component-library/src/assets/styles/main';

//SimpleSuggest styles override Bootstrap validation styles. In order to get the two to work together we need to block existing and add new simple suggest styles...
.custom-suggestions {
  border-radius: 5px;
  border: 1px solid #aaa;
  box-shadow: 8px 8px 8px grey;
  z-index: 1000;
}
.custom-suggestion-item {
  border-bottom: 1px solid #aaa;
  padding: 0.5em;
  cursor: pointer;
}
.custom-suggestion-item.selected {
  background-color: #2832d5;
  color: $dp-white;
}
.custom-suggestion-item.hover {
  background-color: #2874d5;
  color: $dp-white;
}
//End simple suggest custom styles.

// Styles below needed in addition to global styles. Eventually we should do away with these and everything should live in global styles.
@media screen and (min-width: 768px) {
  body {
    background: linear-gradient(0deg, rgba(6, 3, 16, 0.4), rgba(0, 159, 223, 0.3)), url('~@/assets/background-3500px.jpg');
    background-size: 184%;
    background-position-y: 60px;
    background-position-x: center;
    background-repeat-x: no-repeat;
    overflow-x: hidden;
  }
}
.sub-header {
  margin: 20px 0;
  padding: 15px 0;
  text-align: center;
  border-top: 1px solid $dp-gray-3;
  border-bottom: 1px solid $dp-gray-3;
  p {
    color: $dp-gray-6;
    margin-bottom: 0;
  }
}
</style>
